import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import { Languages, Globe } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const LANGUAGES = [
  { code: "pt", name: "Portugues", nativeName: "Portugues", flag: "BR" },
  { code: "en", name: "English", nativeName: "English", flag: "US" },
  { code: "es", name: "Espanol", nativeName: "Espanol", flag: "ES" },
  { code: "fr", name: "Francais", nativeName: "Francais", flag: "FR" },
  { code: "de", name: "German", nativeName: "Deutsch", flag: "DE" },
  { code: "ru", name: "Russian", nativeName: "Russkiy", flag: "RU" },
  { code: "ja", name: "Japanese", nativeName: "Nihongo", flag: "JP" },
  { code: "ko", name: "Korean", nativeName: "Hangugeo", flag: "KR" },
  { code: "ar", name: "Arabic", nativeName: "Al-Arabiyyah", flag: "SA" },
  { code: "fil", name: "Filipino", nativeName: "Filipino", flag: "PH" },
  { code: "zh", name: "Chinese", nativeName: "Zhongwen", flag: "CN" },
  { code: "hi", name: "Hindi", nativeName: "Hindi", flag: "IN" },
];

export default function Home() {
  const navigate = useNavigate();
  const { setLanguage, t } = useLanguage();

  const handleLanguageSelect = (langCode) => {
    setLanguage(langCode);
    // Also set as initial source language for translation
    localStorage.setItem("translation_source_lang", langCode);
    navigate("/language-pair");
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center p-4 sm:p-6">
      {/* Logo and Title */}
      <div className="text-center mb-8 sm:mb-12">
        <div className="flex items-center justify-center gap-3 mb-4 sm:mb-6">
          <Languages className="w-10 h-10 sm:w-12 sm:h-12 text-white" />
        </div>
        
        <h1 
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4 font-['Outfit']"
          data-testid="home-title"
        >
          Selecione o seu idioma.
        </h1>
        <p className="text-lg sm:text-xl text-zinc-400">
          Select your language.
        </p>
      </div>

      {/* Language Selection Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 max-w-2xl w-full" data-testid="language-grid">
        {LANGUAGES.map((lang) => (
          <Card
            key={lang.code}
            className="bg-zinc-900/50 border-zinc-800 hover:border-white/30 hover:bg-zinc-800/50 cursor-pointer transition-all duration-200 group"
            onClick={() => handleLanguageSelect(lang.code)}
            data-testid={`language-option-${lang.code}`}
          >
            <CardContent className="p-4 sm:p-6 flex flex-col items-center justify-center text-center">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-zinc-800 group-hover:bg-zinc-700 flex items-center justify-center mb-2 sm:mb-3 transition-colors">
                <Globe className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
              </div>
              <span className="text-white font-semibold text-base sm:text-lg">
                {lang.nativeName}
              </span>
              <span className="text-zinc-500 text-xs sm:text-sm mt-1">
                {lang.name}
              </span>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Footer hint */}
      <p className="mt-8 sm:mt-12 text-zinc-600 text-xs sm:text-sm text-center px-4">
        Real-time translation between two languages.
      </p>

      {/* Copyright */}
      <p className="mt-4 text-zinc-700 text-[10px] sm:text-xs text-center px-4">
        {t("footerCopyright")}
      </p>
    </div>
  );
}
